import type { FunctionComponent } from "react";
import { useCallback, useState } from "react";
import {
  StyledArrow,
  StyledTitle,
  StyledWrapper,
  StyledChildren,
} from "./styles";
import { Icon, Text } from "@smartsuite/react-ui/lib";

interface ActivityDetailsTriggerGroupProps {
  children: React.ReactNode;
  title: string;
  onClick?: () => void;
}

export const ActivityDetailsTriggerGroup: FunctionComponent<
  ActivityDetailsTriggerGroupProps
> = ({ title, children, onClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = useCallback(() => {
    setIsExpanded((prev) => !prev);
    onClick?.();
  }, [onClick]);

  return (
    <StyledWrapper isExpanded={isExpanded}>
      <StyledTitle onClick={handleToggle}>
        <StyledArrow isExpanded={isExpanded}>
          <Icon name="arrow-down-small" transition={true} />
        </StyledArrow>
        <Text size="l" weight="medium">
          {title}
        </Text>
      </StyledTitle>
      {isExpanded && <StyledChildren>{children}</StyledChildren>}
    </StyledWrapper>
  );
};
